export default {
  edit_selection: 'Auswahl bearbeiten',
};
